
export class Tipologia {
  
    codice: String;
    denominazione: String;
  }
  